import {
  Box,
  Divider,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  Modal,
  Switch,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  CalendarToday,
  EmailOutlined,
  FaceOutlined,
  HomeOutlined,
  LocationOnOutlined,
  PhoneIphoneOutlined,
} from "@material-ui/icons";
import {
  CommunicationMarketingConsent,
  FranchiseAgreementAcceptance,
} from "@hubcapp/graphql/types/gateway";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { useMutationUpdateLead } from "../hooks";
import { useSnackbar } from "notistack";
import ButtonCTA from "@hubcapp/views/AcceptancePageComponent/UI/ButtonCTA";
import React, { useState } from "react";
import clsx from "clsx";

type Props = {
  isOpened: boolean;
  setIsOpenedModal: (bool: boolean) => void;
  data: FranchiseAgreementAcceptance | undefined;
  refetch: () => void;
};

const useStyles = makeStyles(() => ({
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "690px",
    background: "#FFFFFF",
    padding: "48px 102px 10px 102px",
    overflow: "scroll",
    maxHeight: "95vh",
    "@media (max-width: 767px)": {
      width: "100%",
      padding: "48px 14px 96px 14px",
      top: 0,
      transform: "translate(-50%, 0)",
      maxHeight: "100vh",
    },
  },
  buttonSelectTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "56px",
    height: "48px",
    padding: 0,
    boxSizing: "border-box",
    background: "#FFFFFF",
    border: "2px solid #C7C8CA !important",
    borderRadius: "4px !important",
    textTransform: "capitalize",
    "&.Mui-selected": {
      color: "#2B2D32",
      background: "transparent",
    },
  },
  itemBsm: {
    "&.Mui-selected": {
      border: "2px solid #F9812A !important",
    },
  },
  itemAa: {
    "&.Mui-selected": {
      border: "2px solid #FFCC00 !important",
    },
  },
  radioGroup: {
    padding: "0 50px 0 50px",
    marginBottom: "30px",
  },
  labelInput: {
    fontFamily: "New Transport AA !important",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#2B2D32",
    marginBottom: "8px",
    marginTop: "26px",
  },
  modalTitle: {
    fontFamily: "New Transport AA",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "28px",
    textAlign: "center",
    letterSpacing: "0.3px",
    color: "#2B2D32",
    marginBottom: "5%",
  },
  fontBsm: {
    fontFamily: "Poppins !important",
    "& *": {
      fontFamily: "Poppins !important",
    },
  },
  fontAa: {
    fontFamily: "New Transport AA !important",
    "& *": {
      fontFamily: "New Transport AA !important",
    },
  },
  switch: {
    float: "right",
    marginTop: "-5%",
  },
  last: {
    marginTop: "54px",
  },
  divider: {
    marginBottom: "10px",
  },
  buttonGroup: {
    marginTop: "48px",
    marginBottom: "48px",
    display: "flex",
    justifyContent: "end",
    gap: "12px",
  },
  toggleGroup: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "24px",
    "@media (max-width: 767px)": {
      gap: "14px",
    },
  },
  toggleGroupBsm: {
    gridTemplateColumns: "repeat(4, 1fr)",
    display: "grid",
    gap: "24px",
    "@media (max-width: 767px)": {
      gap: "14px",
    },
  },
  textInputWrapper: {
    margin: 0,
    "& input:disabled": {
      cursor: "not-allowed",
    },
  },
  switchWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  switchAa: {
    "& .Mui-checked": {
      color: "#FFCC00",
    },
    "& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track": {
      background: "#FFCC00",
    },
  },
  switchBsm: {
    "& .Mui-checked": {
      color: "#F9812A",
    },
    "& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track": {
      background: "#F9812A",
    },
  },
  icon: {
    opacity: 0.4,
  },
}));

const ModalModifyPersonalDetailsComponent: React.FC<Props> = ({
  isOpened,
  setIsOpenedModal,
  data,
  refetch,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => setIsOpenedModal(false);
  const [title, setTitle] = useState(data?.title);
  const idUpdate = data?.personKey || "";
  const [emailAddressUpdate] = useState(data?.emailAddress);
  const [cityUpdate, setCityUpdate] = useState(data?.city);
  const [firstNameUpdate, setFirstNameupdate] = useState(data?.firstName);
  const [lastNameUpdate, setLastnameUpdate] = useState(data?.surname);
  const [mobileNumberUpdate, setMobileNumberUpdate] = useState(
    data?.phoneNumber,
  );
  const [addressUpdate, setAddressUpdate] = useState(data?.address);
  const [dateOfBirthUpdate, setDateOfBirthUpdate] = useState(data?.dateOfBirth);
  const [licenceNumberUpdate, setLicenceNumberUpdate] = useState(
    data?.drivingNumber,
  );
  const [adiNumberUpdate] = useState(data?.adiNumber);
  const [postCodeUpdate, setPostCodeUpdate] = useState(data?.zipCode);
  const [contactPreferencesUpdate, setContactPreferencesUpdate] = useState<
    CommunicationMarketingConsent
  >({
    email: !!data?.communication?.marketing?.email,
    sms: !!data?.communication?.marketing?.sms,
    phone: !!data?.communication?.marketing?.phone,
    post: !!data?.communication?.marketing?.post,
  });
  const [isRefetching, setIsRefetching] = useState(false);
  const handletitle = (
    event: React.MouseEvent<HTMLElement>,
    newTitle: string,
  ) => {
    if (newTitle) setTitle(newTitle);
  };

  const mutationResultHandlers = {
    onCompleted: async () => {
      setIsRefetching(true);
      try {
        await refetch();
      } catch {
        enqueueSnackbar(
          "Unable to load updated personal details, please refresh the page or contact support",
          { variant: "error", role: "alert" },
        );
      }
      setIsRefetching(false);
      setIsOpenedModal(false);
    },
    onError: () => {
      enqueueSnackbar(
        "Unable to update personal details, please try again or contact support",
        { variant: "error", role: "alert" },
      );
    },
  };

  const [
    updatePersonalDetails,
    { loading: isUpdating },
  ] = useMutationUpdateLead(mutationResultHandlers);

  const handleSubmit = () =>
    updatePersonalDetails({
      variables: {
        id: idUpdate,
        salutation: title,
        firstName: firstNameUpdate,
        lastName: lastNameUpdate,
        mobileNumber: mobileNumberUpdate || undefined,
        emailAddress: emailAddressUpdate || "",
        address: {
          line1: addressUpdate,
          town: cityUpdate,
          postcode: postCodeUpdate,
        },
        dateOfBirth: dateOfBirthUpdate,
        licenceNumber: licenceNumberUpdate,
        communication: {
          marketing: contactPreferencesUpdate,
          reminder: { sms: !!data?.communication?.reminder },
        },
        channel: data?.channel,
      },
    });

  const isLoading = isUpdating || isRefetching;

  return (
    <>
      <Modal
        open={isOpened}
        onClose={handleClose}
        className={clsx({
          [classes.fontBsm]: data?.brand === "BSM",
          [classes.fontAa]: data?.brand !== "BSM",
        })}
      >
        <Box className={classes.box}>
          <Typography variant="h1" className={classes.modalTitle}>
            Edit your details below
          </Typography>
          <>
            <InputLabel htmlFor="component-simple">
              <Typography className={classes.labelInput}>Title</Typography>
            </InputLabel>
            <ToggleButtonGroup
              value={title}
              exclusive
              onChange={handletitle}
              aria-label="Title"
              className={classes.toggleGroup}
            >
              {["Mr", "Miss", "Mrs", "Ms", "Mx"].map(value => (
                <ToggleButton
                  key={value}
                  disabled={isLoading}
                  className={clsx(classes.buttonSelectTitle, {
                    [classes.itemBsm]: data?.brand === "BSM",
                    [classes.itemAa]: data?.brand !== "BSM",
                  })}
                  value={value}
                  aria-label={value}
                >
                  {value}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
            <div>
              <Typography className={classes.labelInput}>First Name</Typography>
              <TextField
                disabled={isLoading}
                value={firstNameUpdate}
                id="firstName"
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={e => setFirstNameupdate(e.target.value)}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <FaceOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>Surname</Typography>
              <TextField
                disabled={isLoading}
                value={lastNameUpdate}
                id="surname"
                fullWidth
                margin="normal"
                onChange={e => setLastnameUpdate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <FaceOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>
                Date of Birth (DD / MM / YYYY)
              </Typography>
              <KeyboardDatePicker
                disabled={isLoading}
                id="dateOfBirth"
                clearable
                onChange={value => setDateOfBirthUpdate(value)}
                value={dateOfBirthUpdate}
                inputVariant={data?.brand === "BSM" ? "standard" : "outlined"}
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
                fullWidth={true}
                className={classes.textInputWrapper}
                disableFuture
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <CalendarToday
                        className={classes.icon}
                        fontSize="small"
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>Address</Typography>
              <TextField
                disabled={isLoading}
                value={addressUpdate}
                id="address"
                fullWidth
                margin="normal"
                onChange={e => setAddressUpdate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <HomeOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>City</Typography>
              <TextField
                disabled={isLoading}
                value={cityUpdate}
                id="city"
                fullWidth
                onChange={e => setCityUpdate(e.target.value)}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <HomeOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>Postcode</Typography>
              <TextField
                disabled={isLoading}
                value={postCodeUpdate}
                id="postCode"
                fullWidth
                margin="normal"
                onChange={e => setPostCodeUpdate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <LocationOnOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>
                Email address
              </Typography>
              <TextField
                value={emailAddressUpdate}
                id="emailAddress"
                disabled
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <EmailOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>
                Phone number
              </Typography>
              <TextField
                disabled={isLoading}
                value={mobileNumberUpdate}
                id="phoneNumber"
                fullWidth
                onChange={e => setMobileNumberUpdate(e.target.value)}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <PhoneIphoneOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>
                Driving license number
              </Typography>
              <TextField
                disabled={isLoading}
                value={licenceNumberUpdate}
                id="drivingLicenseNumber"
                fullWidth
                onChange={e => setLicenceNumberUpdate(e.target.value)}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <FaceOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Typography className={classes.labelInput}>
                Instructor number
              </Typography>
              <TextField
                id="adiNumber"
                value={adiNumberUpdate}
                disabled
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                variant={data?.brand === "BSM" ? "standard" : "outlined"}
                className={classes.textInputWrapper}
                InputProps={{
                  startAdornment: data?.brand === "BSM" && (
                    <InputAdornment position="start">
                      <FaceOutlined className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className={classes.last}>
              <Typography className={classes.labelInput}>
                Contact preferences
              </Typography>

              {data?.brand === "BSM" ? (
                <ToggleButtonGroup
                  exclusive
                  aria-label="Title"
                  className={(classes.toggleGroup, classes.toggleGroupBsm)}
                  onChange={(e, value) => {
                    setContactPreferencesUpdate(prevState => ({
                      ...prevState,
                      [value]: !prevState[
                        value as keyof CommunicationMarketingConsent
                      ],
                    }));
                  }}
                  value={(Object.keys(contactPreferencesUpdate) as Array<
                    keyof CommunicationMarketingConsent
                  >).filter(key => contactPreferencesUpdate[key])}
                >
                  {["Email", "SMS", "Phone", "Post"].map(value => (
                    <ToggleButton
                      key={value}
                      disabled={isLoading}
                      className={clsx(classes.buttonSelectTitle, {
                        [classes.itemBsm]: data?.brand === "BSM",
                        [classes.itemAa]: data?.brand !== "BSM",
                      })}
                      value={value.toLowerCase()}
                      aria-label={value}
                    >
                      {value}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              ) : (
                <>
                  <p className={classes.switchWrapper}>
                    <Typography>Email</Typography>
                    <FormControlLabel
                      disabled={isLoading}
                      className={classes.switchAa}
                      checked={contactPreferencesUpdate.email}
                      control={<Switch />}
                      label={undefined}
                      onChange={(e, status) =>
                        setContactPreferencesUpdate(prevState => ({
                          ...prevState,
                          email: status,
                        }))
                      }
                    />
                  </p>
                  <Divider className={classes.divider} />
                  <p className={classes.switchWrapper}>
                    <Typography>SMS</Typography>
                    <FormControlLabel
                      disabled={isLoading}
                      className={classes.switchAa}
                      checked={contactPreferencesUpdate.sms}
                      control={<Switch />}
                      label={undefined}
                      onChange={(e, status) =>
                        setContactPreferencesUpdate(prevState => ({
                          ...prevState,
                          sms: status,
                        }))
                      }
                    />
                  </p>
                  <Divider className={classes.divider} />
                  <p className={classes.switchWrapper}>
                    <Typography>Telephone</Typography>
                    <FormControlLabel
                      disabled={isLoading}
                      className={classes.switchAa}
                      checked={contactPreferencesUpdate.phone}
                      control={<Switch />}
                      label={undefined}
                      onChange={(e, status) =>
                        setContactPreferencesUpdate(prevState => ({
                          ...prevState,
                          phone: status,
                        }))
                      }
                    />
                  </p>
                  <Divider className={classes.divider} />
                  <p className={classes.switchWrapper}>
                    <Typography>Post</Typography>
                    <FormControlLabel
                      disabled={isLoading}
                      className={classes.switchAa}
                      checked={contactPreferencesUpdate.post}
                      control={<Switch />}
                      label={undefined}
                      onChange={(e, status) =>
                        setContactPreferencesUpdate(prevState => ({
                          ...prevState,
                          post: status,
                        }))
                      }
                    />
                  </p>
                  <Divider className={classes.divider} />
                </>
              )}
            </div>
            <div className={classes.buttonGroup}>
              <ButtonCTA
                disabled={isLoading}
                brand={data?.brand}
                onClickHandler={() => {
                  setIsOpenedModal(false);
                }}
                buttonCancel
                label="Cancel"
              />
              <ButtonCTA
                disabled={isLoading}
                loading={isLoading}
                brand={data?.brand}
                onClickHandler={handleSubmit}
                label="Confirm"
              />
            </div>
          </>
        </Box>
      </Modal>
    </>
  );
};

export default ModalModifyPersonalDetailsComponent;
